import { Code, ConnectError } from '@connectrpc/connect';
export function proposalLoadErrorMessage(error) {
    if (error instanceof ConnectError) {
        if (error.code === Code.PermissionDenied) {
            return "You don't have access to this project. Contact your admin to request access.";
        }
        if (error.code === Code.NotFound) {
            return 'This project may have been deleted or does not exist.';
        }
    }
    return 'Failed to load project. Please try refreshing the page.';
}
